var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.lineItems),function(lineItem){return [_c('InvoiceLineItem',{key:lineItem.uuid,attrs:{"line-item":lineItem}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }